// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__SSv3X","inputDescription":"styles_inputDescription__2ZmNC"};